export default class TimestampControl {
  constructor (element, args) {
    let div = document.createElement('div')
    this.input = document.createElement('input')
    this.input.id = window.PRIM.getUUID()
    this.setValue(args.value)
    this.input.type = 'text'
    this.input.autocapitalize = 'off'
    this.input.autocorrect = 'off'
    this.input.spellcheck = 'false'
    this.input.pattern = '\d{4}(-\d{2}(-\d{2}( \d{2}(:\d{2}(:\d{2})?)?)?)?)?'
    this.input.disabled = args.readonly ? 'disabled' : ''
    this.input.onchange = args.onchange
    this.label = document.createElement('label')
    this.label.innerHTML = args.label
    this.label.htmlFor = this.input.id

    let onclick = () => {
      if (args.readonly)
      {
        return
      }
      this.setValue(new Date())
      this.input.dispatchEvent(new Event('change', { bubbles: true }))
    }

    let button = document.createElement('button')
    button.className = 'icon'
    button.innerHTML = '\ue138'
    button.onclick = onclick

    let fragment = document.createDocumentFragment()
    fragment.appendChild(div)
    div.appendChild(this.label)
    div.appendChild(this.input)
    div.appendChild(button)

    element.appendChild(fragment)
  }

  setLabel (text) {
    this.label.innerHTML = text
  }

  getValue () {
    return this.input.value ? new Date(this.input.value).toISOString() : null
  }

  setValue (value) {
    this.input.value = value ? window.PRIM.getUtcTimestamp(new Date(value)).toISOString().substring(0, 19).replace('T', ' ') : ''
  }
}


// WEBPACK FOOTER //
// ./js/lib/ui/TimestampControl.js